module.exports = __webpack_public_path__ + "img/icon-warning-flood-orange.0c9f1801.svg";